import { Card as CardType } from "@/types/General";
import { FC, Suspense } from "react";
import { DownloadCard } from "./Download";
import { ResourceCard } from "./ResourceCard";
import { UseCaseCard } from "./UseCaseCard";
import { EventCard } from "./Event";
import { NewsroomCard } from "./Newsroom";
import { IntegrationCard } from "./Integration";
import { ProductCard } from "./Product";

export const Card: FC<CardType> = (props) => {
  switch (props.type) {
    case "Download":
      return <DownloadCard {...props} />;
    case "Resource":
      return <ResourceCard {...props} />;
    case "Use Case":
    case "Solution":
      return <UseCaseCard {...props} />;
    case "Event":
      return (
        <Suspense>
          <EventCard {...props} />
        </Suspense>
      );
    case "Newsroom":
      return <NewsroomCard {...props} />;
    case "Integration":
      return <IntegrationCard {...props} />;
    case "Product":
      return <ProductCard {...props} />;
  }
};
